<template>
  <div>
    <div
      class="plan-row"
      @mouseenter="isHovered = true"
      @mouseleave="isHovered = false"
      @click="node.children && node.children.length ? (isOpen = !isOpen) : undefined"
    >
      <span class="plan-icon">
        <span v-if="!node.id_pai" class="plan-bullet">●</span>
        <span v-else class="plan-connector">└</span>
      </span>
      <div class="plan-name-col">
        <span class="plan-name" :class="{ 'is-root': !node.id_pai }">{{ node.descricao }}</span>
        <span v-if="dreGrupoLabel" class="plan-dre d-block">DRE: {{ dreGrupoLabel }}</span>
      </div>
      <div class="plan-actions" v-show="isHovered">
        <span v-if="!node.id_pai" @click.stop="addChild" class="action-btn text-primary">+ Adicionar sub</span>
        <span @click.stop="showModal" class="action-btn text-primary">Editar</span>
        <span @click.stop="deleteNode" class="action-btn text-danger">Excluir</span>
      </div>
    </div>

    <b-collapse :visible="isOpen">
      <div class="children-container">
        <TreeNode
          v-for="(child, index) in node.children"
          :key="child.id || index"
          :node="child"
          :dreGrupos="dreGrupos"
          @add-child="$emit('add-child', $event)"
          @delete-node="$emit('delete-node', $event)"
        />
      </div>
    </b-collapse>

    <b-modal v-model="modalVisible" title="Editar Plano de Contas" centered size="lg">
      <b-row>
        <b-col md="10">
          <b-form-group label="Descrição">
            <b-form-input v-model="editedName" maxlength="50"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="10" v-if="node.id_pai">
          <b-form-group label="Grupo DRE:" label-for="edit-dre-grupo-select">
            <b-form-select
              id="edit-dre-grupo-select"
              v-model="editedDreGrupo"
              :options="dreGruposOptions"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <template #modal-footer="{ cancel }">
        <div>
          <b-button variant="primary" @click="saveEdit" ref="saveEdit" class="mr-2">Salvar</b-button>
          <b-button @click="cancel()">Cancelar</b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { SistemaMixin } from "@/modules/Application";

export default {
  name: "TreeNode",
  mixins: [SistemaMixin],
  props: {
    node: {
      type: Object,
      required: true,
    },
    dreGrupos: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    dreGruposOptions() {
      return [
        { value: null, text: "Não classificado" },
        ...this.dreGrupos.map((g) => ({ value: g.id, text: g.label })),
      ];
    },
    dreGrupoLabel() {
      if (!this.node.dre_grupo) return null;
      const grupo = this.dreGrupos.find((g) => g.id === this.node.dre_grupo);
      return grupo ? grupo.label : null;
    },
  },
  data() {
    return {
      isOpen: true,
      isHovered: false,
      modalVisible: false,
      editedName: this.node.descricao,
      editedDreGrupo: this.node.dre_grupo || null,
    };
  },
  methods: {
    showModal() {
      this.editedName = this.node.descricao;
      this.editedDreGrupo = this.node.dre_grupo || null;
      this.modalVisible = true;
    },
    async saveEdit() {
      this.addLoadingToButton("saveEdit");
      this.node.descricao = this.editedName;
      this.node.dre_grupo = this.editedDreGrupo;
      await this.$http.post("/financeiro/update-plano", this.node);
      this.$toast.success("Plano atualizado com sucesso!");
      this.modalVisible = false;
      this.removeLoadingToButton("saveEdit");
    },
    addChild() {
      this.$emit("add-child", this.node);
    },
    deleteNode() {
      this.$emit("delete-node", this.node);
    },
  },
};
</script>

<style scoped>
.plan-row {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  border-bottom: 1px solid #f0f0f0;
  min-height: 48px;
  cursor: pointer;
  transition: background 0.12s;
}
.plan-row:hover {
  background: #f8f9fa;
}
.plan-icon {
  width: 20px;
  flex-shrink: 0;
  margin-right: 8px;
  text-align: center;
}
.plan-bullet {
  color: #28a745;
  font-size: 9px;
}
.plan-connector {
  color: #aaa;
  font-size: 15px;
  font-family: monospace;
}
.plan-name-col {
  flex: 1;
}
.plan-name {
  font-size: 14px;
  color: #343a40;
}
.plan-name.is-root {
  font-weight: 600;
}
.plan-dre {
  font-size: 11px;
  color: #6c757d;
}
.plan-actions {
  display: flex;
  gap: 14px;
  align-items: center;
}
.action-btn {
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
}
.action-btn:hover {
  text-decoration: underline;
}
.children-container {
  margin-left: 28px;
}
</style>